import { useEffect } from "react";

const TAWK_SCRIPT_ID = "tawk-to-widget-script";
const TAWK_SCRIPT_URL = "https://embed.tawk.to/67406f242480f5b4f5a26fd8/1id9r4aej";

const TawkToWidget = () => {
  useEffect(() => {
    // react-snap executes effects while generating static HTML. Loading Tawk there
    // serializes its temporary scripts/iframes into the production build and then
    // the browser loads a second widget during hydration.
    if (navigator.userAgent === "ReactSnap") return undefined;

    let openWhenReady = false;
    const previousOpenTawkChat = window.openTawkChat;

    const openChat = () => {
      if (typeof window.Tawk_API?.maximize === "function") {
        window.Tawk_API.maximize();
        openWhenReady = false;
      } else {
        openWhenReady = true;
      }
    };

    window.openTawkChat = openChat;
    window.Tawk_API = window.Tawk_API || {};
    const previousOnLoad = window.Tawk_API.onLoad;
    window.Tawk_API.onLoad = () => {
      if (typeof previousOnLoad === "function") previousOnLoad();
      window.Tawk_API.hideWidget();
      if (openWhenReady) openChat();
    };

    // Do not inject a duplicate if the component is remounted.
    if (document.getElementById(TAWK_SCRIPT_ID)) return undefined;

    const tawkScript = document.createElement("script");
    tawkScript.id = TAWK_SCRIPT_ID;
    tawkScript.async = true;
    tawkScript.src = TAWK_SCRIPT_URL;
    tawkScript.charset = "UTF-8";
    tawkScript.setAttribute("crossorigin", "*");

    document.body.appendChild(tawkScript);

    return () => {
      window.openTawkChat = previousOpenTawkChat;
    };
  }, []);

  return null;
};

export default TawkToWidget;
